import { Designation, State } from "../types"

// TODO: write tests

export abstract class FormSubmission {
  protected state: State

  constructor(state: State) {
    this.state = state
    this.buildPayload()
  }

  static create(state: State): FormSubmission {
    if (state.frequency.type === "once") {
      return new OneTimeFormSubmission(state)
    } else {
      return new RecurringFormSubmission(state)
    }
  }

  protected buildPayload(): void {}

  abstract submit(): Promise<void>
}

type DesignationResource = {
  type: string
  attributes: { amount: string }
  relationships: { fund: { data: { type: string; id: string } } }
}

class OneTimeFormSubmission extends FormSubmission {
  private payload?: {
    data: { attributes: { stripe_token: string | undefined } }
    included: DesignationResource[]
  }

  async submit(): Promise<void> {
    // TODO: once we have confirmation tokens in place, actually make the
    // network request here
    alert(JSON.stringify(this.payload, null, 2))
  }

  protected buildPayload() {
    this.payload = {
      data: {
        attributes: {
          // TODO: replace with confirmation token
          stripe_token: "WE_DONT_HAVE_A_REAL_TOKEN_YET",
        },
      },
      included: this.state.designations.map(this.designationToResource),
    }
  }

  private designationToResource(designation: Designation): DesignationResource {
    return {
      type: "Designation",
      attributes: { amount: designation.amount },
      relationships: {
        fund: {
          data: {
            type: "Fund",
            id: designation.fundId,
          },
        },
      },
    }
  }
}

class RecurringFormSubmission extends FormSubmission {
  submit(): Promise<void> {
    alert("Submitting recurring donation is not implemented yet")
    return Promise.resolve()
  }
}
